import React, { Component } from 'react';

import Dialog from '../../../raven/modals/dialog';
import Events from '../../../../common/events';
import MNotesView from './notesView';

import CognitoUtil from '../../../../aws/cognito/cognitoUtil';

export default class MNotesHistoryModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            newNote: ''
        };
    }

    getNotes()
    {
        // perform ajax calls to get it the next state
        let url = "" + this.props.dataStore.prefix1 + "ajaxbig"
                + "?stage=" + this.props.stage
                + "&type=notes"
                + "&raven=" + this.props.raven.raven_id
                + "&ravenunit=" + this.props.raven.raven_unit_id;

        this.props.dataStore.queryLoop(url, (items) => {
            console.debug("Raven notes data:", items);
            // Update the state with the retrieved notes
            this.setState({ notes: items });
        });
    }

    componentDidMount() {
        this.getNotes();
    }

    onNoteChange = (event) => {
        if(event && this.state.newNote !== event.target.value) {
            this.setState({newNote: event.target.value });
        }
    }

    onAddNote = () => {
        if(this.state.newNote === null || this.state.newNote === '') {
            this.setState({message: "No Notes to Send" });
            return;
        }

        document.dispatchEvent(new CustomEvent(Events.SHOW_LOADING_PAGE,
                { detail: { loadingMessage: 'Adding Note' } }));

        let prefix = this.props.dataStore.prefix2;

        let url = prefix + "updatenotes"
            + "?stage=" + this.props.stage
            + "&type=" + "raven_unit"
            + "&ravenid=" + this.props.raven.raven_id
            + "&ravenUuid=" + this.props.raven.raven_uuid
            + "&ravenUnitId=" + this.props.raven.raven_unit_id
            + "&notes=" + this.state.newNote;

        this.setState({message: null, newNote: ''});

        return fetch(url,
            { method: 'POST', headers: { Authorization: CognitoUtil.getCurrentUserToken() } } )
          .then((response) => {
            return response.json();
          }).then((json) => {
              // We grabbed the json.  Put it in the state
              document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));

              this.setState({message: json});

              // Requery the notes after setting a new one
              setTimeout( () => {this.getNotes() }, 5000);
          }).catch((error) => {

              document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
              let message = "Unknown error adding note" + error;

              this.setState({message: message});

              console.error("Add Note Error", error);
          });
    }

    render() {

        return (
            <Dialog
                size="medium"
                className="test"
                label={this.props.title}
                isOpen={this.props.isOpen}
                onClose={this.props.onClose}
                >
                    <div>
                        <div className="row">
                            <div className="col-12">
                                {
                                    this.state.notes && !this.state.loading ? 
                                        this.state.notes.Error ? 
                                            <p>{this.state.notes.Error}</p> :
                                        this.state.notes.length !== 0 ?  
                                            <MNotesView 
                                                data={this.state.notes} 
                                                /> : 
                                            <p>No Notes Data...</p> :
                                        <p>Loading...</p>
                                }
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-1">
                                <label>New Note</label>
                            </div>
                            <div className="col-10">
                                <input autoComplete="off" type="text" value={this.state.newNote} name="newnote" onChange={this.onNoteChange}></input>
                            </div>
                            <div className="col-1">
                                <div className="actions">
                                    <button onClick={this.onAddNote} >
                                        Add Note
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div>{this.state.message}</div>
                            </div>
                        </div>
                    </div>
            </Dialog>
        );
    }

}
